module.exports = __webpack_public_path__ + "img/8.a14d5e57.jpg";